/**
 * Removes all keys from target. Compatible with Vue's reactivity model without being dependent on Vue.
 * @param target
 */
export function unsetAll (target) {
  Object.keys(target).forEach(key => {
    delete target[key];
  });

  const ob = target.__ob__;
  if (ob) {
    ob.dep.notify();
  }

  return target;
}



// WEBPACK FOOTER //
// ./src/shared/util/object.js